import React from 'react';
import PropTypes from 'prop-types';

import { Alert, Divider, Slider } from 'antd';
import { Form, FormItem, Select } from 'formik-antd';

import { simpleFilterOptions } from 'utils/form';
import { commuteOptions } from 'utils/shifts';

import StagePropTypes from './prop-types';
import DayGrid from './day-grid';
import { DB_PREFIX, TITLE } from './constants';
import { hasShift, removeShift } from './utils';

const description = (
  <div>
    <p>
      These will help MyShifts match you with potential employers needs and
      hence lead to more opportunities for work.
    </p>
    <p>
      The more shifts you are available to work the more potential opportunities
      will be available to you.
    </p>
    Please ensure that if you say you are available to work on a particular day
    or time and shift that you can. If not this may affect your worker rating if
    you fail to accept work opportunities.
  </div>
);

const descriptionTravel = (
  <div>
    <p>
      This will help MyShifts make the best match between your choices and the
      needs of the potential employer.
    </p>
    <p>
      We aim to show work opportunities as near to you home address as possible.
    </p>
    <p>
      We accept that your mode of transport will be your choice, all the
      employers needs to know is, you can realistically arrive on time and get
      home safely after each shift.
    </p>
  </div>
);

const ShiftsInfoForm = ({ values, setFieldValue, children }) => {
  return (
    <Form layout="vertical">
      <h1>{TITLE}</h1>

      <Alert
        message="Please indicate which shifts you are available to work ie. Early, Late, Nights & Long days."
        description={description}
        type="info"
        showIcon
      />

      <DayGrid
        value={values[DB_PREFIX].dateTimeAvailable}
        onChange={(e) => {
          const arr = Object.values(values[DB_PREFIX].dateTimeAvailable);
          const { target } = e;
          const { value } = target;

          const hasValue = hasShift(arr, value);
          const mutated = hasValue ? removeShift(arr, value) : [value, ...arr];

          setFieldValue(`${DB_PREFIX}.dateTimeAvailable`, { ...mutated });
        }}
      />

      <Divider />

      <FormItem name={`${DB_PREFIX}.hourRate`} label="Hour Rate Range">
        <Slider
          min={10}
          max={100}
          step={1}
          tipFormatter={(v) => `£${v}`}
          tooltipPlacement="bottom"
          range
          tooltipVisible
          value={[
            values[DB_PREFIX].hourRate['0'],
            values[DB_PREFIX].hourRate['1'],
          ]}
          onChange={(e) => {
            setFieldValue(`${DB_PREFIX}.hourRate`, {
              ...e,
            });
          }}
        />
      </FormItem>

      <Divider />

      <Alert
        message="Please indicate the distance you are able to commute for Shifts"
        description={descriptionTravel}
        type="info"
        showIcon
      />

      <FormItem
        name={`${DB_PREFIX}.travelOptions`}
        label="Commute distance options"
      >
        <Select
          name={`${DB_PREFIX}.travelOptions`}
          showSearch
          allowClear
          placeholder="Please select a level"
          optionFilterProp="children"
          filterOption={simpleFilterOptions}
        >
          {commuteOptions.map(({ value, label }) => (
            <Select.Option value={value} key={value}>
              {label}
            </Select.Option>
          ))}
        </Select>
      </FormItem>

      {children}
    </Form>
  );
};

ShiftsInfoForm.propTypes = {
  children: PropTypes.node,
  values: StagePropTypes.isRequired,
  setFieldValue: PropTypes.func.isRequired,
};

ShiftsInfoForm.defaultProps = {
  children: null,
};

export default ShiftsInfoForm;
